var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 1.794C0 .874.704.128 1.571.128H20.43C21.298.128 22 .874 22 1.794c0 .922-.702 1.667-1.571 1.667H1.57C.704 3.461 0 2.716 0 1.794m0 8.334C0 9.206.704 8.46 1.571 8.46H20.43c.869 0 1.571.745 1.571 1.667s-.702 1.666-1.571 1.666H1.57C.704 11.795 0 11.05 0 10.128m20.429 10H1.57C.704 20.128 0 19.383 0 18.46s.704-1.666 1.571-1.666H20.43c.869 0 1.571.744 1.571 1.666s-.702 1.667-1.571 1.667"
  })));
};
export default SvgHamburger;